import { Anchor, Table } from "@mantine/core";
import { UserView } from "../../components/user/UserView";
import { getFullName } from "../../helpers/stringHelper";
import type { Apprentice } from "../../models/apprentice";
import { occupationTranslations } from "../../models/enums/occupation";
import { getSchoolTranslation } from "../../models/school";
import { SCHOOL_DAYS } from "../select/WeekdayMultiSelect";

type ApprenticeViewProps = {
  apprentice: Apprentice;
};

export function ApprenticeView({ apprentice }: ApprenticeViewProps) {
  const firstSchoolDay = apprentice.school_days[0];
  const secondSchoolDay = apprentice.school_days[1];
  const schoolDays = (
    <>
      <Table.Tr key={`school.${firstSchoolDay?.id}-${secondSchoolDay?.id}`}>
        <Table.Th>Schule</Table.Th>
        <Table.Td>{firstSchoolDay ? getSchoolTranslation(firstSchoolDay.school) : "-"}</Table.Td>
        <Table.Td>{secondSchoolDay ? getSchoolTranslation(secondSchoolDay.school) : "-"}</Table.Td>
      </Table.Tr>
      <Table.Tr key={`class_name.${firstSchoolDay?.id}-${secondSchoolDay?.id}`}>
        <Table.Th>Klasse</Table.Th>
        <Table.Td>{firstSchoolDay ? firstSchoolDay.class_name : "-"}</Table.Td>
        <Table.Td>{secondSchoolDay ? secondSchoolDay.class_name : "-"}</Table.Td>
      </Table.Tr>
      <Table.Tr key={`days.${firstSchoolDay?.id}-${secondSchoolDay?.id}`}>
        <Table.Th>Schultage</Table.Th>
        <Table.Td>
          {firstSchoolDay ? firstSchoolDay.days.map((day) => SCHOOL_DAYS.find((d) => d.value === day)?.label).join(", ") : "-"}
        </Table.Td>
        <Table.Td>
          {secondSchoolDay ? secondSchoolDay.days.map((day) => SCHOOL_DAYS.find((d) => d.value === day)?.label).join(", ") : "-"}
        </Table.Td>
      </Table.Tr>
      <Table.Tr key={`bms.${firstSchoolDay?.id}-${secondSchoolDay?.id}`}>
        <Table.Th>BMS</Table.Th>
        <Table.Td>{firstSchoolDay ? (firstSchoolDay.school.bms ? "Ja" : "Nein") : "-"}</Table.Td>
        <Table.Td>{secondSchoolDay ? (secondSchoolDay.school.bms ? "Ja" : "Nein") : "-"}</Table.Td>
      </Table.Tr>
    </>
  );

  return (
    <Table variant="vertical" layout="fixed" withTableBorder withColumnBorders>
      <Table.Tbody>
        <UserView<Apprentice> userType={apprentice} colSpan={2} />
        <Table.Tr key="occupation">
          <Table.Th>Beruf</Table.Th>
          <Table.Td colSpan={2}>{occupationTranslations[apprentice.occupation]}</Table.Td>
        </Table.Tr>
        <Table.Tr key="apprenticeSupervisor">
          <Table.Th>Berufsbildner/in</Table.Th>
          <Table.Td colSpan={2}>
            <Anchor href={`mailto:${apprentice.apprentice_supervisor?.user.email}`}>
              {apprentice.apprentice_supervisor && getFullName(apprentice.apprentice_supervisor)}
            </Anchor>
          </Table.Td>
        </Table.Tr>
        <Table.Tr key="company">
          <Table.Th>Lehrbetrieb</Table.Th>
          <Table.Td colSpan={2}>{apprentice.company.name}</Table.Td>
        </Table.Tr>
        <Table.Tr key="parents">
          <Table.Th>Eltern</Table.Th>
          <Table.Td>
            <Anchor href={`mailto:${apprentice.parents[0]?.email}`}>{getFullName(apprentice.parents[0])}</Anchor>
          </Table.Td>
          <Table.Td>
            <Anchor href={`mailto:${apprentice.parents[1]?.email}`}>{getFullName(apprentice.parents[1])}</Anchor>
          </Table.Td>
        </Table.Tr>
        {schoolDays}
      </Table.Tbody>
    </Table>
  );
}
